'use client';

import type { QuoteBlock } from '@impact/types';

interface Props {
  block: QuoteBlock;
  editing?: boolean;
}

/**
 * Magazine pullquote variant: giant centered quote with massive decorative quotation marks
 */
export function QuoteMagazinePullquote({ block, editing }: Props) {
  const { text, author, role } = block.data;

  return (
    <div className="my-16 max-w-4xl mx-auto px-8 text-center">
      <div className="relative">
        <span className="absolute -top-8 left-1/2 -translate-x-1/2 select-none font-serif text-[10rem] leading-none text-primary/10 pointer-events-none">
          &ldquo;
        </span>
        <blockquote
          className="relative text-3xl md:text-5xl font-bold text-foreground leading-tight"
          {...(editing ? { 'data-editable': 'data.text' } : {})}
        >
          {text}
        </blockquote>
      </div>
      {author || role ? (
        <div className="mt-10 flex items-center justify-center gap-3">
          <span className="h-px w-12 bg-border" />
          <div className="text-sm">
            {author ? (
              <span
                className="font-semibold text-foreground"
                {...(editing ? { 'data-editable': 'data.author' } : {})}
              >
                {author}
              </span>
            ) : null}
            {author && role ? <span className="text-muted-foreground">, </span> : null}
            {role ? (
              <span
                className="text-muted-foreground"
                {...(editing ? { 'data-editable': 'data.role' } : {})}
              >
                {role}
              </span>
            ) : null}
          </div>
          <span className="h-px w-12 bg-border" />
        </div>
      ) : null}
    </div>
  );
}
